<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();
const { resetCurrentMenuOpen } = useAccountMenuStore();

useSeo({
  title: t('account_menu.rewards'),
});

onMounted(() => {
  // side effect visual do layout antigo — não roda com o Minha Conta V2
  if (isUserV2Enabled.value) {
    return;
  }

  resetCurrentMenuOpen();
});
</script>

<template>
  <UserV2ScreenRewards v-if="isUserV2Enabled" />
  <UserAccountPageLayout
    v-else
    :title="$t('account_menu.rewards')"
  >
    <UserRewards />
  </UserAccountPageLayout>
</template>

<style module lang="scss">
// style
</style>
